/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SymbolFairPriceDto,
    SymbolFairPriceDtoFromJSON,
    SymbolFairPriceDtoToJSON,
    UpsertSymbolFairPriceDto,
    UpsertSymbolFairPriceDtoFromJSON,
    UpsertSymbolFairPriceDtoToJSON,
} from '../models';

export interface SymbolFairPriceControllerGetBySymbolIdRequest {
    symbolId: string;
}

export interface SymbolFairPriceControllerUpsertRequest {
    upsertSymbolFairPriceDto: UpsertSymbolFairPriceDto;
}

/**
 * 
 */
export class SymbolFairPriceApi extends runtime.BaseAPI {

    /**
     * Get fair price by symbol id
     */
    async symbolFairPriceControllerGetBySymbolIdRaw(requestParameters: SymbolFairPriceControllerGetBySymbolIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SymbolFairPriceDto>> {
        if (requestParameters.symbolId === null || requestParameters.symbolId === undefined) {
            throw new runtime.RequiredError('symbolId','Required parameter requestParameters.symbolId was null or undefined when calling symbolFairPriceControllerGetBySymbolId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbol-fair-price/{symbolId}`.replace(`{${"symbolId"}}`, encodeURIComponent(String(requestParameters.symbolId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SymbolFairPriceDtoFromJSON(jsonValue));
    }

    /**
     * Get fair price by symbol id
     */
    async symbolFairPriceControllerGetBySymbolId(requestParameters: SymbolFairPriceControllerGetBySymbolIdRequest, initOverrides?: RequestInit): Promise<SymbolFairPriceDto> {
        const response = await this.symbolFairPriceControllerGetBySymbolIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upsert fair price
     */
    async symbolFairPriceControllerUpsertRaw(requestParameters: SymbolFairPriceControllerUpsertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SymbolFairPriceDto>> {
        if (requestParameters.upsertSymbolFairPriceDto === null || requestParameters.upsertSymbolFairPriceDto === undefined) {
            throw new runtime.RequiredError('upsertSymbolFairPriceDto','Required parameter requestParameters.upsertSymbolFairPriceDto was null or undefined when calling symbolFairPriceControllerUpsert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/symbol-fair-price`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertSymbolFairPriceDtoToJSON(requestParameters.upsertSymbolFairPriceDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SymbolFairPriceDtoFromJSON(jsonValue));
    }

    /**
     * Upsert fair price
     */
    async symbolFairPriceControllerUpsert(requestParameters: SymbolFairPriceControllerUpsertRequest, initOverrides?: RequestInit): Promise<SymbolFairPriceDto> {
        const response = await this.symbolFairPriceControllerUpsertRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
